import React, { useState } from "react";
import styled from "styled-components";
import { MdOutlineArrowOutward, MdLockOutline } from "react-icons/md";
import CredentialModal from "./CredentialModal";

export default function ProjectBox({ img, title, text, to, action, credentials }) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Wrapper className="flexColumn">
        <ImgBtn
          className="aniamte pointer"
          onClick={action ? () => action(to) : null}
        >
          <Img className="radius8" src={img} alt="project" />
        </ImgBtn>
        <h3 className="font20 extraBold textCenter">{title}</h3>
        <TextContainer className="font13">{text}</TextContainer>
        <ButtonsContainer>
          {credentials && (
            <CredentialButton onClick={() => setShowModal(true)}>
              <MdLockOutline style={{ marginRight: '5px', fontSize: '18px' }} /> Credentials
            </CredentialButton>
          )}
          <TryButton className="flexSpaceCenter" onClick={() => action(to)}>
            Try it <MdOutlineArrowOutward />
          </TryButton>
        </ButtonsContainer>
      </Wrapper>

      {credentials && (
        <CredentialModal 
          showModal={showModal} 
          setShowModal={setShowModal} 
          credentials={credentials} 
        />
      )}
    </>
  );
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  padding: 20px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  }

  h3 {
    padding-bottom: 10px;
    margin-top: 15px;
  }
`;
const TextContainer = styled.p`
  flex-grow: 1;
  text-align: center;
  margin-bottom: 20px;
  color: #555;
  line-height: 1.6;
`;
const Img = styled.img`
  width: 100%;
  height: 240px;
  object-fit: cover;
  border-radius: 12px;
`;
const ImgBtn = styled.button`
  background-color: transparent;
  border: 0px;
  outline: none;
  padding: 0px;
  margin: 0px;
  width: 100%;
  :hover > img {
    opacity: 0.8;
    transition: opacity 0.3s ease;
  }
`;
const ButtonsContainer = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
  margin-top: auto;
`;
const TryButton = styled.button`
  background-color: #7620ff;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  font-weight: 600;

  &:hover {
    background-color: #5a18c8;
    transition: all 0.3s ease-in-out;
  }
`;
const CredentialButton = styled.button`
  background-color: #f3f4f6;
  color: #4b5563;
  border: 1px solid #e5e7eb;
  padding: 10px 15px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;

  &:hover {
    background-color: #e5e7eb;
    transition: all 0.2s ease-in-out;
  }
`;
